import * as React from 'react'

import {Button, Form, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import {LoginIndexResponse} from "../../../src/swagger";

// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from '../../assets/css/app.scss';
import './index.scss';
import {observable, runInAction} from "mobx";
import moment from "moment";
import {toDateStr} from "../../../src/utils/datetime/moment";
import portableFetch from "portable-fetch";
import {redirect} from "../../../src/common/Router/routerCommon";

import permit from "../../assets/viewImg/permit.gif";
import permit_lounge from "../../assets/viewImg/permit_lounge.gif";
import {getQueryParam} from "../../../src/utils/react/routerUtil";
import {RouteComponentProps} from "react-router";
import {GlobalStore} from "../../../src/store/GlobalStore";
import {FastlaneService} from "../../service/FastlaneService";
import {jsxIf} from "../../../src/utils/react/jsxHelpers";
import {HistoryConstants} from "../../../src/constants/Views/Histories/HistoryConstants";


// const FormItem = Form.Item;

@observer
class UseFastlane extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;
  fastLaneService = new FastlaneService(this.formUtils, 1);
  loungeService = new FastlaneService(this.formUtils, 2);
  loungeSecondService = new FastlaneService(this.formUtils, 2, 1)

  isFastlane = 1;
  useLounge = 0;
  isLoungeSecond = 0;
  loungeSecondTokenNum = 0;

  @observable
  permitInfo: any = {};

  tokens: any = {};

  componentWillMount() {
    this.init();
  }

  init = async () => {
    let tokens;
    let userId;
    await loginUserStore.getLoginUser().then((loginUserInfo: LoginIndexResponse) => {
      userId = loginUserInfo.id;
      tokens = localStorage.getItem(`tokens.${userId}`);
    });
    this.tokens = JSON.parse(tokens || "{}");

    loginUserStore.getLoginUser().then(() => {
    });

    let isLane = getQueryParam("is_lane") as string;
    this.isFastlane = parseInt(isLane);
    this.isLoungeSecond = parseInt(getQueryParam("is_lounge_second") as string);
    this.useLounge = parseInt(getQueryParam("use_lounge") as string);

    let flightDate = toDateStr(moment(getQueryParam("flight_date")!.replace(/\-/g, ""), "YYYYMMDD"))!.replace(/\-/g, "");
    let bodyObj = {
      flight_date: flightDate,
      is_lane: isLane,
      token: this.tokens[(Boolean(this.isLoungeSecond) ? this.loungeSecondTokenNum : isLane) + "-" + toDateStr(flightDate)!],
    };
    const method = "POST";
    const body = JSON.stringify(bodyObj);
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    portableFetch(KIX_GBC_API_PATH + "/check_permit", {
      method,
      headers,
      body,
      credentials: "include"
    }).then(async (res: any) => {
      const json = await res.json();
      runInAction(() => {
        this.permitInfo = json.value;
      });
      if (!this.permitInfo.valid_period_start) {
        redirect("/");
      }

      // 2020.07.01 add 【脆弱性対応】レスポンス値（ハッシュと平文）を比較する ※ 不正時は強制リダイレクト
      const bcryptjs = require('bcryptjs');
      if (!bcryptjs.compareSync(String(this.permitInfo.remaining), this.permitInfo.remaining_hash) || 
          !bcryptjs.compareSync(this.permitInfo.valid_period_start, this.permitInfo.valid_period_start_hash) || 
          !bcryptjs.compareSync(this.permitInfo.valid_period_end, this.permitInfo.valid_period_end_hash) || 
          !bcryptjs.compareSync(String(userId), this.permitInfo.id_hash)) {
        message.error("レスポンスの値が不正です。");
        redirect("/");
      }
    }).catch((_e: any) => {
      message.error("通信に失敗しました。画面を更新して下さい。");
    });
  };

  componentWillReceiveProps(nextProps: { moduleFlag?: boolean } & FormComponentProps & RouteComponentProps<any>) {
    if (nextProps.location !== this.props.location) {
      GlobalStore.setRouting<any>(nextProps);
      this.init();
    }
  }

  componentWillUnmount() {
  }

  renderFastLane = () => {
    return <>
      <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>Fast Lane を利用する</h2>

      <div className={commonStyles.f}>
        <div className={commonStyles.fCenter + " fCnter"} style={{width: "40%", margin: "2em"}}>
          {/*{this.permitInfo.valid_period_start && this.permitInfo.valid_period_start <= toDateStr(moment())!*/}
          {/*? <img src={permit}/>*/}
          {/*: <p className={appStyles.textWhite + " textWhite} style={{fontSize: "1.1em"}}>※搭乗日前の為許可証を表示できません。</p>*/}
          {/*}*/}
          {jsxIf(this.permitInfo.valid_period_start, () => (
            <img src={permit} style={{width: "100%"}}/>
          )).endIf()}
        </div>

        <div className={commonStyles.f1}>
          <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter + " fCnter"}>
            <div style={{fontSize: "1.1em", width: "100%"}}>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{
                     padding: "0.5em",
                     width: "100%",
                   }}>
                <span>有効期間</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{
                     marginBottom: "1em",
                     borderBottom: "0.5px solid #bfc4d8",
                     padding: "0.5em",
                     width: "100%",
                   }}>
                <span
                  >{this.permitInfo.valid_period_start} - {this.permitInfo.valid_period_end}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>企業コード</span>
                <span
                  className={commonStyles.fItemRight}>{(("000") + loginUserStore.loginUserInfo.companyId).substr(-4)}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>会員ID</span>
                <span className={commonStyles.fItemRight}>{loginUserStore.loginUserInfo.userCode}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>残り利用回数</span>
                <span className={commonStyles.fItemRight}>{this.permitInfo.remaining} 回／年</span>
              </div>
            </div>
          </div>
          <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
            <div className={appStyles.textWhite + " textWhite"} style={{width: "100%"}}>
              ※会員様のみご利用いただけます。<br/>
              ※関西国際空港以外ではご利用いただけません。<br/>
              ※許可証の有効期間は搭乗日から起算して３日間です。<br/>
              ※印刷した許可証はスタッフが回収させていただきます。<br/>
            </div>
          </div>
        </div>
      </div>
    </>;
  };

  renderLounge = () => {
    return <>
      <h2 className={appStyles.h2blue + " " + commonStyles.f}
          style={{marginTop: "2em", marginBottom: "2em"}}>ラウンジを利用する<span
        className={commonStyles.fItemRight} style={{fontSize: "0.75em"}}>(長距離便ご利用者様限定)</span></h2>

      <div className={commonStyles.f}>
        <div className={commonStyles.fCenter + " fCnter"} style={{width: "40%", margin: "2em"}}>
          {/*{this.permitInfo.valid_period_start && this.permitInfo.valid_period_start <= toDateStr(moment())!*/}
          {/*? <img src={permit_lounge}/>*/}
          {/*: <p className={appStyles.textWhite + " textWhite} style={{fontSize: "1.1em"}}>※搭乗日前の為許可証を表示できません。</p>*/}
          {/*}*/}
          <img src={permit_lounge} style={{width: "100%"}}/>
        </div>

        <div className={commonStyles.f1}>
          <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter + " fCnter"}>
            <div style={{fontSize: "1.1em", width: "100%"}}>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{
                     padding: "0.5em",
                     width: "100%",
                   }}>
                <span>有効期間</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{
                     marginBottom: "1em",
                     borderBottom: "0.5px solid #bfc4d8",
                     padding: "0.5em",
                     width: "100%",
                   }}>
                <span
                >{this.permitInfo.valid_period_start} - {this.permitInfo.valid_period_end}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>企業コード</span>
                <span
                  className={commonStyles.fItemRight}>{(("000") + loginUserStore.loginUserInfo.companyId).substr(-4)}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>会員ID</span>
                <span className={commonStyles.fItemRight}>{loginUserStore.loginUserInfo.userCode}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>残り利用回数</span>
                <span className={commonStyles.fItemRight}>{this.permitInfo.remaining} 回／年</span>
              </div>
            </div>
          </div>
          <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
            <div className={appStyles.textWhite + " textWhite"} style={{width: "100%"}}>
              ※ラウンジのカウンターで、利用許可証と搭乗券またはeチケットをご提示下さい。<br/>
              ※会員様のご利用席に限りがあり、ご利用をご遠慮いただく場合がございます。<br/>
              また、満席の場合はご利用をお待ちいただくか、ご利用いただけない場合がございます。<br/>
              ※営業時間：8：00～22：00（最終受付21：30）<br/>
              営業時間は変更される場合がありますので、当日現地でご確認ください。<br/>
              ※会員様のみご利用いただけます。<br/>
              ※関西国際空港以外ではご利用いただけません。<br/>
              ※許可証の有効期間は搭乗日から起算して３日間です。<br/>
              ※印刷した許可証はスタッフが回収させていただきます。<br/>
            </div>
          </div>
        </div>
      </div>
    </>;
  };

  renderLoungeSecond = () => {
    return <>
      <h2 className={appStyles.h2blue + " " + commonStyles.f}
          style={{marginTop: "2em", marginBottom: "2em"}}>ラウンジを利用する</h2>

      <div className={commonStyles.f}>
        <div className={commonStyles.fCenter + " fCnter"} style={{width: "40%", margin: "2em"}}>
          <img src={permit_lounge} style={{width: "100%"}}/>
        </div>

        <div className={commonStyles.f1}>
          <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter + " fCnter"}>
            <div style={{fontSize: "1.1em", width: "100%"}}>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>利用ラウンジ</span>
                <span className={commonStyles.fItemRight}>{HistoryConstants.useLounge[this.useLounge]}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                style={{
                  padding: "0.5em",
                  width: "100%",
                }}>
                <span>有効期間</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                style={{
                    marginBottom: "1em",
                    borderBottom: "0.5px solid #bfc4d8",
                    padding: "0.5em",
                    width: "100%",
                  }}>
                <span
                >{this.permitInfo.valid_period_start} - {this.permitInfo.valid_period_end}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                  style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>企業コード</span>
                <span
                  className={commonStyles.fItemRight}>{(("000") + loginUserStore.loginUserInfo.companyId).substr(-4)}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                  style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>会員ID</span>
                <span className={commonStyles.fItemRight}>{loginUserStore.loginUserInfo.userCode}</span>
              </div>
              <div className={appStyles.textWhite + " textWhite" + " " + commonStyles.f}
                  style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em", width: "100%"}}>
                <span>残り利用回数</span>
                <span className={commonStyles.fItemRight}>{this.permitInfo.remaining} 回／年</span>
              </div>
            </div>
          </div>
          <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
            <div className={appStyles.textWhite + " textWhite"} style={{width: "100%"}}>
              ※ラウンジのカウンターで、利用許可証と搭乗券またはeチケットをご提示下さい。<br/>
              ※会員様のご利用席に限りがあり、ご利用をご遠慮いただく場合がございます。<br/>
              また、満席の場合はご利用をお待ちいただくか、ご利用いただけない場合がございます。<br/>
              ※営業時間：<br/>
              ・ラウンジオーサカ　6：30～20：00（最終締切19：45）<br/>
              ・ラウンジ神戸　6：15～最終便出発時間の10分前まで<br/>
              営業時間は変更される場合がありますので、当日現地でご確認ください。<br/>
              ※会員様のみご利用いただけます。<br/>
              ※大阪国際空港・神戸空港以外ではご利用いただけません。<br/>
              ※許可証の有効期間は搭乗日から起算して３日間です。<br/>
              ※印刷した許可証はスタッフが回収させていただきます。<br/>
            </div>
          </div>
        </div>
      </div>
    </>;
  };

  render() {
    // const {getFieldDecorator} = this.props.form;
    let content;
    if (this.isFastlane === 1) {
      content = this.renderFastLane();
    } else if (Boolean(this.isLoungeSecond)) {
      content = this.renderLoungeSecond();
    } else {
      content = this.renderLounge();
    }

    return (
      <><KixGbcMemberLayout>
        {content}

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
          <Button onClick={() => (window as any).print()} size={"large"} className={`${appStyles.buttonGray}`}
                  style={{color: "white", padding: "0 5em 0 5em", height: "3.5em"}}>
            印刷する
          </Button>
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
          <Button onClick={() => {
            runInAction(() => {
              if (this.isFastlane === 1) {
                this.fastLaneService.isCancelModalVisible = true
              } else if (Boolean(this.isLoungeSecond)) {
                this.loungeSecondService.isCancelModalVisible = true
              } else {
                this.loungeService.isCancelModalVisible = true;
              }
            });
          }} size={"large"} className={`${appStyles.buttonGray}`}
                  style={{color: "white", padding: "0 5em 0 5em", height: "3.5em"}}>
            キャンセルする
          </Button>
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
          {/*{this.isFastlane != 1 &&*/}
          {/*<Button onClick={this.fastLaneService.redirectInquiryOrConfirm} size={"large"}*/}
          {/*        className={`${appStyles.buttonDarkBlue}`}*/}
          {/*        style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>*/}
          {/*  Fast Laneを利用する*/}
          {/*</Button>*/}
          {/*}*/}
          {this.isFastlane != 2 &&
          <Button onClick={this.loungeService.redirectInquiryOrConfirm} size={"large"}
                  className={`${appStyles.buttonDarkBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            ラウンジを利用する
          </Button>
          }
          <Button onClick={() => redirect("/my_page")} size={"large"} className={`${appStyles.buttonDarkBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            マイページ・会員証
          </Button>
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter + " fCnter"}>
          <Button onClick={() => redirect("/")} size={"large"} className={`${appStyles.buttonDeepBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            GBC会員専用TOPへ
          </Button>
        </div>

        {this.fastLaneService.displayModal()}
        {this.loungeService.displayModal()}
        {this.loungeSecondService.displayModal()}
      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(UseFastlane)

